import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import { isNull } from '../../../utils/chart';

import scss from './MessagesList.module.scss';

function LinkScores({ r1, r2, total }) {
  const { t } = useTranslation('resonance');

  const linkScoresData = [
    {
      label: 'R1',
      value: isNull(r1) ? '-/-' : r1 + '%',
      color: scss.blue,
    },
    {
      label: 'R2',
      value: isNull(r2) ? '-/-' : r2 + '%',
      color: scss.green,
    },
    {
      label: t('total'),
      value: isNull(total) ? '-/-' : total + '%',
    },
  ];

  return (
    <div className={scss.linkScores}>
      {linkScoresData.map(({ label, value, color }) => (
        <div key={label}>
          <span>{label}</span>
          <span className={clsx(color)}>{value}</span>
        </div>
      ))}
    </div>
  );
}

export default LinkScores;
